import {sendPetition} from '../../js/scripts';

var state = {
	clientLogged: false,
	sessionInfo: {}
}

var getters = {
	clientLogged: state => state.clientLogged,
	sessionInfo: state => state.sessionInfo
}

var actions = {
	tryLogin({commit}, url){
		
		sendPetition(
			url,
			(data)=>{
				switch (data.result.statusCode){
					case 200:
						commit('setLoggedStatus', true);
						sessionStorage.setItem('loginStatus', true);
						commit('setSessionInfo', data);
						sessionStorage.setItem('sessionInfo', JSON.stringify(data))
						//generate session variable for php
						//to read this data use the following line:
						//session_arr = JSON.parse(sessionStorage.getItem('sessionInfo'))
						break;
					case 401: 
						commit('setSessionInfo', {'result': {statusCode: 401}});
						sessionStorage.setItem('sessionInfo', {'result': {statusCode: 401}})
						break;
					case 500:
						commit('setSessionInfo', data);
						commit('setSessionInfo', {'result': {statusCode: 500}});
						//sessionStorage.setItem('sessionInfo', {'result': {statusCode: 500}})
						break;
					default:
						console.log('Error: Unknown code');
				}
			}
		)
	},
	forceLogin({commit}){
		commit('setLoggedStatus', true);
		sessionStorage.setItem('loginStatus', true);
	}
}

var mutations = {
	setLoggedStatus (state, val){
		state.clientLogged = val;
	},
	setSessionInfo (state, arr){
		state.sessionInfo = arr;
	}
}

export var account = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};